import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
    ControlModel,
    CONTROL_TYPE_ID_WIND_SPEED
} from '../../../types/control';
import { useRPC } from '../../../hooks/rpc';
import { WindControlComponent } from './component';
import { useDebounce } from '../../../hooks/debounce';
import { useFilterSelector } from '../../../hooks/filter-selector';
import { useMessage } from '../../../hooks/message';
import { WindSpeedParameters } from '../../../types/control';
import windSpeedIcon from '../../../assets/images/icons/wind-speed.png';

type Props = {
    control: ControlModel;
};

export const WindSpeedControl = memo(function TemperatureControl({ control }: Props) {
    const windSpeedControlTypeList = useFilterSelector(
        state => state.control.controlTypeList,
        controlType => controlType.id === (CONTROL_TYPE_ID_WIND_SPEED),
        []);
    useEffect(() => {
        console.log(windSpeedControlTypeList);
    }, [windSpeedControlTypeList]);
    const updateWindSpeed = useDebounce((id: string, windSpeed: number) => {
        rpc.updateWindSpeed(id, windSpeed).catch(failure)
    }, 200)
    const currentWindSpeed = useMemo(() => (
        (control.parameters as WindSpeedParameters).current_wind_speed ||
        (control.parameters as WindSpeedParameters).measurement_range_min || 0
    ), [control]);
    const [setWindSpeed, setSetWindSpeed] = useState(
        (control.parameters as WindSpeedParameters).set_wind_speed ||
        (control.parameters as WindSpeedParameters).measurement_range_min || 0
    );
    const windSpeedChangeClick = useCallback((isPlus: boolean) => {
        let newSetWindSpeed = setWindSpeed;
        newSetWindSpeed += isPlus ? 0.5 : -0.5
        newSetWindSpeed = Math.round(newSetWindSpeed * 2) / 2;
        newSetWindSpeed = Math.max(
            newSetWindSpeed, (
                control.parameters as WindSpeedParameters
            ).measurement_range_min || 0);
        newSetWindSpeed = Math.min(
            newSetWindSpeed, (
                control.parameters as WindSpeedParameters
            ).measurement_range_max || 10
        );
        setSetWindSpeed(newSetWindSpeed);
        updateWindSpeed(control.id, newSetWindSpeed);
    }, [setWindSpeed, control.parameters, control.id, updateWindSpeed]);
    const [rpc] = useRPC();
    const { failure } = useMessage()
    const controlRef = useRef<ControlModel>();
    controlRef.current = control;

    return (
        <WindControlComponent
            control={control}
            icon={windSpeedIcon}
            click={() => { }}
            windSpeedChangeClick={windSpeedChangeClick}
            setWindSpeed={setWindSpeed.toString()}
            currentWindSpeed={currentWindSpeed.toString()}
        />
    );
});
